module.exports = __webpack_public_path__ + "img/node-retailer-transparent.3fe68814.webp";